import React, { useEffect, useState } from "react";
import schoolApi from "../../api/schoolApi";
import "./FeeReceipt.css";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "react-bootstrap";
import jwt_decode from "jwt-decode";
const FeeReceipt = React.forwardRef(({ receiptData }, receiptRefs) => {
  const [studentRecord, setStudentRecord] = useState();
  const [headRecords, setHeadRecords] = useState([]);
  const [depoMonths, setMonths] = useState([]);
  const [depositRecords, setdepositRecords] = useState([]);
  const [filterMonths, setFilterMonths] = useState([]);
  const [tenantCode, setTenantCode] = useState(null);
  useEffect(() => {
    if (receiptData) {
      async function init() {
        try {
          sessionStorage.getItem("token");
          const user = jwt_decode(sessionStorage.getItem("token"));
          setTenantCode(user.tenantcode);
          let session = receiptData?.sessionid
            ? receiptData?.sessionid
            : receiptData?.session_id;
          const result = await schoolApi.fetchFeeDepositsByStudentId(
            receiptData?.student_addmission_id,
            session,
            receiptData?.deposit_id
          );


          const session_id = result.result[0].session_id;
          const current_session = await schoolApi.getSessionById(session_id);
         
          const filteredMonthsName = getMonthNamesBetweenDates(
            current_session?.result?.startdate,
            current_session?.result?.enddate
          );
         
          setFilterMonths(filteredMonthsName);


          if (!result || result.success === false) {
            return;
          }

          const depoRecords = result?.result[0];
         

          setdepositRecords(depoRecords);
          let netPayableAmount = 0;
          let headArray = [];
          let totalTransportfee = 0;
          let installmentTotalDueAmount = 0;
          let months = [];


          if (depoRecords?.installments?.length > 0) {
            depoRecords.installments = depoRecords?.installments
              .map((installment) => {
                const notmonthlytype = installment.month.split(" to ");
               
               

                if (notmonthlytype.length === 1) {
                  return filteredMonthsName.includes(installment.month)
                    ? installment
                    : null;
                } else {
                  const [startMonth, endMonth] = notmonthlytype.map((m) =>
                    m.trim()
                  );
                  const startIndex = filteredMonthsName.indexOf(startMonth);
                  const endIndex = filteredMonthsName.indexOf(endMonth);

                  if (startIndex !== -1 && endIndex !== -1) {
                    const monthsInRange = filteredMonthsName.slice(
                      startIndex,
                      endIndex + 1
                    );
                   
                    return { ...installment, expandedMonths: monthsInRange };
                  } else {
                    console.warn(
                      "Invalid month range in installment: ",
                      installment.month
                    );
                    return null;
                  }
                }
              })
              .filter(Boolean);

            depoRecords.installments.sort((a, b) => {
              const aFirstMonth = Array.isArray(a.expandedMonths)
                ? a.expandedMonths[0]
                : a.month;
              const bFirstMonth = Array.isArray(b.expandedMonths)
                ? b.expandedMonths[0]
                : b.month;
              return (
                filteredMonthsName.indexOf(aFirstMonth) -
                filteredMonthsName.indexOf(bFirstMonth)
              );
            });

           
          }

          depoRecords?.installments?.forEach((res) => {
            if (!depoMonths.some((depo) => depo.month === res.month)) {
              depoMonths.push(res.month);
            }

            res.heads.forEach((head) => {
              const existingHead = headArray.find(
                (prev) => prev.headid === head.headid
              );

              if (existingHead) {
                existingHead.head_amount += parseInt(head.head_amount);

                head?.concession?.forEach((heds) => {
                  const existingDiscount = existingHead.discount.find(
                    (exds) => exds.discountid === heds.discountid
                  );
                 

                  if (existingDiscount) {
                    existingDiscount.concession_value += heds.concession_value;
                  } else {
                    existingHead.discount.push(heds);
                  }
                });
              } else {
                headArray.push({
                  ...head,
                  head_amount: parseInt(head.head_amount),
                  month: depoMonths,
                  discount: head?.concession,
                });
              }
            });

            months.push({ month: res.month });
            installmentTotalDueAmount += parseInt(res.installment_due_amount);
            totalTransportfee += parseInt(res.transport_fee);
            netPayableAmount +=
              parseInt(res.installment_amount) +
              parseInt(res.transport_fee) +
              parseInt(depoRecords?.late_fee) +
              parseInt(depoRecords?.previous_due);
          });

          headArray.push({
            headname: "Transport Fee",
            head_amount: totalTransportfee,
          });
          headArray.push({
            headname: "Late Fee",
            head_amount: depoRecords?.late_fee,
          });
          headArray.push({
            headname: "Previous Due",
            head_amount: depoRecords?.previous_due,
          });

          depoRecords.due_amount = installmentTotalDueAmount;
          depoRecords.netPayableAmount = netPayableAmount;

          setMonths(months);
         

          setStudentRecord(depoRecords);
          setHeadRecords(headArray.filter((res) => res.head_amount > 0));
         
        } catch (error) {}
      }
      init();
    }
  }, [receiptData]);
 

  function getMonthNamesBetweenDates(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const result = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const monthName = monthNames[currentDate.getMonth()];
      if (!result.includes(monthName)) {
        result.push(monthName);
      }

      currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return result;
  }

  const convertNumberToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const g = ["", "Thousand", "Million", "Billion", "Trillion"];
    if ((num = num.toString()).length > 15) return "too large";
    let n = ("000000000000000" + num).substr(-15).match(/.{3}/g);
    let str = "";
    for (let i = 0; i < n.length; i++) {
      let hundreds = parseInt(n[i][0]);
      let tens = parseInt(n[i][1]);
      let units = parseInt(n[i][2]);
      let word = "";
      if (hundreds > 0) {
        word += a[hundreds] + " hundred ";
      }
      if (tens > 1) {
        word += b[tens] + " " + a[units];
      } else {
        word += a[10 * tens + units];
      }
      if (word.trim()) {
        str += word + " " + g[n.length - 1 - i] + " ";
      }
    }
    return str.replace(/\s+/g, " ").trim();
  };
  const totalFees = headRecords?.reduce(
    (acc, item) => acc + item?.head_amount,
    0
  );
  const totalDiscount = headRecords.reduce((total, ele) => {
    if (ele.headname !== "") {
     

      if (ele.concession && Array.isArray(ele.concession)) {
        const amount = ele.concession.reduce(
          (acc, item) => acc + (parseInt(item?.concession_value) || 0),
          0
        );
       
        return total + amount;
      }
    }
    if (ele.concession && Array.isArray(ele.concession)) {
      const amount = ele.concession.reduce(
        (acc, item) => acc + (parseInt(item?.concession_value) || 0),
        0
      );
     
      return total + amount;
    }

    return total;
  }, 0);

 

  return (
    <>
      <div className="fee-receipt-container-receipt">
        {studentRecord ? (
          <div
            id="reportContent"
            ref={receiptRefs}
            className="fee-receipt-receipt"
          >
            {["Office Copy", "Parent Copy"].map((copyType, idx) => (
              <div key={idx} className="receipt-copy-receipt">
                <header className="header-receipt">
                  <Row>
                    <Col lg={3}>
                      <img
                        src={`/${tenantCode}-sidebar-logo.png`}
                        style={{ width: "100px", height: "100px" }}
                        alt=""
                      />
                    </Col>
                    <Col lg={6}>
                      <h1>{studentRecord.school_name}</h1>
                      <p>
                        {studentRecord.school_address},<br />
                        State - {studentRecord.state}, {studentRecord.country},
                        <br />
                        Pin code - {studentRecord.pincode}
                      </p>
                    </Col>
                    <Col lg={3}>
                      <p className="float-end">{copyType}</p>
                    </Col>
                  </Row>
                </header>
                {}
                <h4 class="text-center border-dark border-top border-bottom container-fluid">
                  Fee Receipt ({studentRecord.session})
                </h4>
                {}
                <div className="receipt-info-receipt">
                  <div className="info-left-receipt">
                    <p>
                      <strong>Receipt No :</strong>{" "}
                      {studentRecord.receipt_number}
                    </p>
                    <p>
                      <strong>Student Name :</strong>{" "}
                      {studentRecord.studentname}
                    </p>
                    <p>
                      <strong>Registration No :</strong>{" "}
                      {studentRecord.registration_id}
                    </p>
                    <p>
                      <strong>Mobile No :</strong> {studentRecord.phone}
                    </p>
                  </div>
                  <div className="info-right-receipt">
                    <p>
                      <strong>Receipt Date :</strong>{" "}
                      {studentRecord.payment_date}
                    </p>
                    <p>
                      <strong>Parent's Name :</strong>{" "}
                      {studentRecord.parent_name}
                    </p>
                    <p>
                      <strong>Class :</strong> {studentRecord.classname} (
                      {studentRecord.sectionname})
                    </p>
                    <p>
                      <strong>Parent's Contact :</strong>{" "}
                      {studentRecord.parentphone}
                    </p>
                  </div>
                </div>
                <table className="table-receipt">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Particulars</th>
                      <th>Due Month</th>
                      <th>Due Amount</th>
                      <th>Concession Amount</th>
                      <th>Paid Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {headRecords?.map((record, index) => {
                     
                  //    if (record.head_amount !== 0) {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{record.headname}</td>
                            {}
                            <td className="month">
                              {record?.month?.map((mon, idx) => {
                               
                                return <span key={idx}>{`${mon} `}</span>;
                              })}
                            </td>
                            <td className="amount">{record.head_amount}</td>
                            <td>
                              {console.log("record?.discount", record)}
                              {record?.discount?.map((res, idx) => {
                               
                               
                                return (
                                  <span key={idx}>
                                    {res.discount_percent !== 0 &&
                                      `${res.discount_name}(${res.concession_value}) `}
                                  </span>
                                );
                              })}
                            </td>
                            <td className="amount">
                              {record?.discount
                                ? record?.discount?.map((res, idx) => {
                                    const discountedAmount =
                                      res.discount_percent !== 0
                                        ? record.head_amount -
                                          res.concession_value
                                        : record.head_amount;
                                    return (
                                      <span key={idx}>{discountedAmount}</span>
                                    );
                                  })
                                : record.head_amount}
                            </td>
                          </tr>
                        );
                  //    }
                     
                    //  return null;
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3" className="text-right">
                        <strong>Total Amount (in Rs):</strong>
                      </td>
                      <td className="amount text-right">
                        <strong>{totalFees}</strong>
                      </td>
                      <td className="amount text-right">
                        {console.log("discount", totalDiscount)}
                        {console.log("depositRecord", depositRecords.discount)}
                        <strong>{depositRecords.discount}</strong>
                      </td>
                      <td className="amount">
                        <strong>{totalFees - depositRecords.discount}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="5" className="text-right">
                        <strong>Deposited Amount (in Rs):</strong>
                      </td>
                      <td className="amount">
                        <strong>{studentRecord.amount}</strong>
                      </td>
                    </tr>
                    {totalFees -
                    depositRecords.discount -
                    studentRecord.amount ? (
                      <tr>
                        <td colSpan="5" className="text-right">
                          <strong>Due Amount (in Rs):</strong>
                        </td>
                        <td className="amount">
                          <strong>
                            {console.log("duee amount", totalDiscount)}
                            {console.log("duee amount", studentRecord.amount)}
                            {totalFees -
                              depositRecords.discount -
                              studentRecord.amount}
                          </strong>
                        </td>
                      </tr>
                    ) : null}
                    <tr>
                      <td colSpan="6" className="text-right">
                        <strong className="text-capitalize">
                          Amount In Words: Rupees{" "}
                          {convertNumberToWords(studentRecord.amount)} Only.
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="6" className="text-right">
                        <strong>Payment Mode:</strong>{" "}
                        {studentRecord.payment_method} |
                        {studentRecord.transaction_no ? (
                          <>
                            <strong>Cheque No. / Transaction Id:</strong>{" "}
                            {studentRecord.transaction_no} |
                          </>
                        ) : null}
                        <strong>Cheque Date / Transaction Date:</strong>{" "}
                        {studentRecord.transaction_date}
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <div className="remarks-receipt">
                  <p>
                    <strong>Remark:</strong> {studentRecord.remark}
                  </p>
                </div>
                <div className="footer-receipt">
                  <p>
                    Generated by {studentRecord.generated_by} on{" "}
                    {studentRecord.generated_date}
                  </p>
                  <p>
                    <strong>NOTE:</strong> FEE IS NOT REFUNDABLE (EXCEPT CAUTION
                    FEE)
                  </p>
                </div>
              </div>
            ))}
            <div className="dotted-line"></div>
          </div>
        ) : (
          <p>No Receipt Found</p>
        )}
      </div>
    </>
  );
});

export default FeeReceipt;
